export default __webpack_public_path__ + "static/media/Group2.ff7ef9b1.png";